import * as React from 'react';
import { StyledRadio } from './Radio.styled';

export interface IRadioProps extends React.PropsWithChildren {
	onChange?: (selected: boolean, name: string, value: string) => void;
	name: string;
	value: string;
	label?: string;
	checked: boolean;
	// In some contexts we need to tweak these values
	activeHighlightStyle?: { top?: number, left?: number };
}

export const Radio: React.FC<IRadioProps> = (props) => {
	const { name, value, label, onChange, checked, children } = props;
	const id = `${name}-${value}`;
	const inputRef = React.useRef<HTMLInputElement | null>(null);

	const handler = (e: React.FormEvent<HTMLElement>) => {
		e.preventDefault();
		inputRef.current?.focus();
		const newChecked = !checked;
		if (onChange) {
			onChange(newChecked, name, value);
		}
	};

	const className = `merlin-radio merlin-radio--${checked ? 'checked' : 'unchecked'} merlin-radio--${name} merlin-radio--${id}`;

	const styledProps = props.activeHighlightStyle ?? {};

	return <StyledRadio {...styledProps} onClick={handler}>
		<div className={`merlin-radio__wrapper`}>
			<label className={className} htmlFor={id}>
				<div className="merlin-radio__container">
					<input
						ref={inputRef}
						type="radio"
						className={`merlin-radio__input ${className}`}
						value={value}
						id={id}
						name={name}
						onChange={handler}
						onKeyPress={(ev) => ev.key === 'Enter' && handler(ev)}
						checked={checked}
					/>
					<div className="merlin-radio__button" onClick={handler}></div>
					<div data-testid={`${id}-radio-label`} className="merlin-radio__label" onClick={handler}>{label || ''}</div>
				</div>
				<div className="merlin-radio__children">
					{children}
				</div>
			</label>
		</div>
	</StyledRadio>;
};
